import * as React from "react";

export const ContentLoading = () => (
  <div className="timeline-wrapper">
    <div className="timeline-item">
      <div className="animated-background" />
    </div>
  </div>
);
